import { OneRmAutoCompleteComponent } from './OneRmAutoCompleteComponent';

export default OneRmAutoCompleteComponent;
